let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b1gz4")).then(() => parcelRequire('736YY'));